angular
  .module('order')

  .factory('OrderExportByCompanyYearBilled', [
    '$http',
    '$timeout',
    '$filter',
    'Dialog',
    function($http, $timeout, $filter, Dialog) {
      const download = () => {
        const url = '@@apiUrl' + '/orders-export-by-company-year-billed';

        return $http({ method: 'GET', url })
          .then(() => {
            $timeout(
              () =>
                new Dialog().info(
                  $filter('translate')('EXPORT_EMAIL_SUCCESS_1') +
                    '\n' +
                    $filter('translate')('EXPORT_EMAIL_SUCCESS_2')
                ),
              200
            );
          })
          .catch(error => {
            Sentry.captureException(error);
            $timeout(
              () =>
                new Dialog().error($filter('translate')('error.RECEIVE_ERR')),
              200
            );
          });
      };

      return { download };
    }
  ]);
